import { render } from "./bundle-card.vue?vue&type=template&id=0464e409&scoped=true&lang=pug"
import script from "./bundle-card.vue?vue&type=script&lang=js"
export * from "./bundle-card.vue?vue&type=script&lang=js"

import "./bundle-card.vue?vue&type=style&index=0&id=0464e409&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0464e409"]])

export default __exports__